<div
  class="checkbox-group"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  [attr.data-layout]="layout"
  [attr.data-disabled]="disabled"
  [attr.data-required]="required"
  [attr.data-error]="hasError"
  [attr.role]="'group'"
  [attr.aria-labelledby]="label ? computedId + '-label' : null"
>
  <!-- Group label -->
  <div *ngIf="label" class="group-label" [id]="computedId + '-label'">
    {{ label }}
    <span *ngIf="required" class="required-indicator" aria-hidden="true"
      >*</span
    >
  </div>

  <!-- Select All checkbox (when more than 2 options) -->
  <div *ngIf="showSelectAll && options.length > 2" class="select-all-wrapper">
    <umss-checkbox
      label="Select All"
      [size]="size"
      [checked]="isAllSelected()"
      [indeterminate]="isIndeterminate()"
      [disabled]="disabled"
      (checkedChange)="toggleAll()"
    >
    </umss-checkbox>
  </div>

  <!-- Checkbox options -->
  <div class="options-container">
    <umss-checkbox
      *ngFor="let option of options; trackBy: trackByValue"
      [label]="option.label"
      [id]="option.id"
      [size]="size"
      [checked]="isSelected(option.value)"
      [disabled]="disabled || !!option.disabled"
      [name]="name"
      [value]="option.value"
      (checkedChange)="onCheckboxChange(option, $event)"
    >
    </umss-checkbox>
  </div>

  <!-- Selection count info -->
  <div *ngIf="maxSelections || minSelections" class="selection-info">
    <small>
      Selected: {{ selectedValues.length }}
      <span *ngIf="maxSelections"> / {{ maxSelections }}</span>
      <span *ngIf="minSelections && !maxSelections">
        (min: {{ minSelections }})</span
      >
    </small>
  </div>

  <!-- Error message -->
  <div *ngIf="hasError && minSelections" class="error-message">
    <small
      >Please select at least {{ minSelections }} option{{
        minSelections > 1 ? 's' : ''
      }}.</small
    >
  </div>
</div>
